module.exports = __webpack_public_path__ + "media/join.8b98f8a7.mp3";